import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import "antd/dist/antd.css";
import "normalize.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// 抑制 ResizeObserver 循环错误
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message.includes('ResizeObserver')
  ) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    return;
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

/* 
React.StrictMode
    App -- Fuck Ant Design 
React.StrictMode>
*/

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
